<template>
	<div class="container">
		<div class="row min-vh-100 align-items-center justify-content-center">
			<div class="col-auto text-center">
				<div class="spinner-border text-primary" role="status">
					<span class="visually-hidden">Loading...</span>
				</div>
				<p class="mt-3 text-muted">Loading report details...</p>
			</div>
		</div>
	</div>
</template>
